import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import useFetchDeclarations from '../hooks/useFetchDeclarations';
import { sanitizeText } from '../utils/SanitizeText';

import Loader from '../components/Loader';
import ListDeclaration from '../components/ListDeclaration';

const DeclarationList = () => {
    const { declarations, fetchDeclarations, loading, error } = useFetchDeclarations();

    const didFetchRef = useRef(false);

    useEffect(() => {
        if (didFetchRef.current) return;
        didFetchRef.current = true;
        fetchDeclarations();
    }, [fetchDeclarations]);

    // if (loading) {
    //     return <div className="flex flex-1 justify-center items-center"><Loader /></div>;
    // }

    if (error) {
        return <div>Erreur : {error}</div>;
    }
    const isLoading = loading || !didFetchRef.current;

    const declarationsSain = declarations
        .map(declaration => ({
            ...declaration,
            Libelle: sanitizeText(declaration.Libelle)
        }));

    const decCount = Array.isArray(declarationsSain) ? declarationsSain.length : 0;

    return (
        <div class="flex-1 px-6 py-4 lg:px-10">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12">
                        <div className="mb-3 w-full rounded-lg bg-gray-900/95 px-4 py-2 shadow-md sm:px-6 sm:py-3">
                            <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
                                <div className="space-y-2">
                                    <nav
                                        id="url"
                                        className="flex items-center gap-2 text-xs font-semibold text-gray-400 sm:text-sm"
                                    >
                                        <Link to="/declarations" class="hover:text-white decoration-orange-600 hover:underline hover:underline-offset-2 transition hover:translate-y-[-2px] duration-300">Declarations</Link>

                                        <span className="cursor-default text-gray-500">/</span>
                                    </nav>

                                    <h1 className="text-xl font-semibold text-white sm:text-2xl">
                                        Liste des déclarations
                                    </h1>

                                    {/* <div className="mt-1">
                                        {isLoading ? (
                                            <span className="inline-flex items-center gap-2 rounded-full bg-gray-700/60 px-4 py-1.5">
                                                <span className="h-4 w-24 animate-pulse rounded-full bg-gray-500/60" />
                                            </span>
                                        ) :
                                            decCount === 0 ? (
                                                <span className="inline-flex items-center gap-2 rounded-full bg-gray-700 px-4 py-1.5 text-xs font-medium text-gray-200">
                                                    <i className="fa-regular fa-circle-xmark text-red-300" />
                                                    Aucune déclaration disponible
                                                </span>
                                            ) : (
                                                <span className="inline-flex items-center gap-2 rounded-full bg-gray-700 px-4 py-1.5 text-xs font-medium text-gray-100">
                                                    <i className="fa-solid fa-scroll text-orange-300" />
                                                    {decCount} {decCount > 1 ? "déclarations" : "déclaration"}
                                                </span>
                                            )}
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                        <ListDeclaration lstDeclarations={declarationsSain} loading={loading} showAdd={false} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeclarationList;
